export default "__VITE_ASSET__b965e379__"